<script>
export default {
   inserted: function (el) {
        var headers = el.getElementsByTagName('ul')[0].children;
        var sections = el.getElementsByClassName('item');
        var types = [];

        var setTab = function(tabId) {
            for(var i = 0; i < headers.length; i++) {
                el.classList.remove(headers[i].dataset.type);
                headers[i].classList.remove('active');
                sections[i].style.display = 'none';
            }
            el.classList.add(types[tabId]);
            headers[tabId].classList.add('active');
            sections[tabId].style.display = 'block';

            document.getElementsByClassName('mobile-menu')[0].getElementsByClassName('mobile-item')[0].innerHTML = headers[tabId].getElementsByTagName('a')[0].innerHTML;
            el.getElementsByTagName('ul')[0].classList.remove('active')
            document.getElementsByClassName('mobile-menu')[0].classList.remove('open')
        }

        var setOnclick = function(ctl, i) {
            ctl.onclick = function(e) {
                e.preventDefault();
                setTab(i);
            }
        }

        var setPointerOnclick = function(ctl, i) {
            ctl.onclick = function() {
                var pointers = document.getElementsByClassName('pointer');
                for(var bi = 0; bi < pointers.length; bi++) {
                    pointers[bi].classList.remove('active')
                }
                ctl.parentElement.classList.add('active')
            }
            ctl.parentElement.getElementsByTagName('svg')[0].onclick = function(e) {
                ctl.parentElement.classList.remove('active');
            }
        }

        var pointers = document.getElementsByClassName('pointer');
        for(var bi = 0; bi < pointers.length; bi++) {
            setPointerOnclick(pointers[bi].getElementsByTagName('i')[0], bi);
        }

        document.getElementsByClassName('mobile-menu')[0].onclick = function() {
            if (el.getElementsByTagName('ul')[0].classList.contains('active')) {
                el.getElementsByTagName('ul')[0].classList.remove('active')
                document.getElementsByClassName('mobile-menu')[0].classList.remove('open')
            } else {
                el.getElementsByTagName('ul')[0].classList.add('active')  
                document.getElementsByClassName('mobile-menu')[0].classList.add('open')
            }
        }

        for(var i = 0; i < headers.length; i++) {
            types.push(headers[i].dataset.type);
            setOnclick(headers[i], i);
        }

        var getUrlParameter = function (name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        };
        var param = getUrlParameter('tab');
        if (param) {
            for(var i = 0; i < headers.length; i++) {
                if (param == headers[i].dataset.type) {
                    setTab(i);
                }
            }
        } else {
            setTab(0);
        }
   }
}
</script>